var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWish2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25743 0C3.16174 0 2.06609 0.429157 1.23935 1.29438C-0.414182 3.0248 -0.412049 5.79765 1.23935 7.52922L7.55106 14.1485C7.60851 14.2088 7.67761 14.2568 7.75416 14.2896C7.83071 14.3224 7.91313 14.3393 7.99641 14.3393C8.07969 14.3393 8.1621 14.3224 8.23865 14.2896C8.3152 14.2568 8.3843 14.2088 8.44176 14.1485C10.5472 11.9451 12.6544 9.73909 14.7599 7.53562C16.4134 5.80517 16.4134 3.03124 14.7599 1.30079C13.1064 -0.429649 10.3772 -0.429686 8.7237 1.30079L7.99961 2.05051L7.27553 1.29438C6.44877 0.429161 5.35312 0 4.25743 0Z",
    fill: "#162C2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWish2);
export default __webpack_public_path__ + "static/media/wish2.cceae881ad1335e798395aedc410906f.svg";
export { ForwardRef as ReactComponent };